import { render } from "./GenealogyTree.vue?vue&type=template&id=c3afc294&scoped=true"
import script from "./GenealogyTree.vue?vue&type=script&lang=js"
export * from "./GenealogyTree.vue?vue&type=script&lang=js"

import "./GenealogyTree.vue?vue&type=style&index=0&id=c3afc294&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3afc294"]])

export default __exports__